import { IconButton } from '@grupoboticario/flora-react';
import { styled } from 'ui/theme';

export const IconButtonShare = styled(IconButton as any)`
  width: 78px;
  height: 90px;
  margin-right: 30px;
  padding: 0px;
`;
